import * as React from 'react';
import { H2 } from '@grandvisionhq/iris-ui';

const FacetPickerHeader = ({ children , rightSlot ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "facet-picker-header"
    }, /*#__PURE__*/ React.createElement(H2, {
        className: "facet-picker-header__text",
        variant: "heading-smallest"
    }, children), rightSlot);
};

export { FacetPickerHeader };
//# sourceMappingURL=FacetPickerHeader.js.map
